import { extractData, getSeoKey } from "api"
import { getWarrantyExtensionsTopTable, WarrantyBaseData } from "api/delek"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import WarrantyExtensionPage from "components/pages/WarrantyExtension"
import { GetStaticProps } from "next"

type WarrantyExtensionStaticProps = {
  pageData: WarrantyBaseData[]
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<
  WarrantyExtensionStaticProps
> = async () => {
  const { data } = await getSeoKey("warrantyExtension")
  const seo = {
    title: data.body.title,
    description: data.body.description,
    keywords: data.body.keywords,
  }
  try {
    const warrantyData = await getWarrantyExtensionsTopTable().then(extractData)
    return {
      props: {
        pageData: warrantyData.data,
        seo: seo,
      },
      revalidate: 60,
    }
  } catch (error) {
    return {
      props: {
        pageData: [],
        seo: seo,
      },
      revalidate: 60,
    }
  }
}

const WarrantyExtension = ({ pageData, seo }: WarrantyExtensionStaticProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <WarrantyExtensionPage data={pageData} />
    </>
  )
}

export default WarrantyExtension
